import { useState } from 'react';
import axiosInstance from 'interceptor/axiosInstance';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { BrandsList } from 'models/BrandsList/BrandsList.model';
import { deserialize } from 'serializr';
import { generatePath } from 'react-router-dom';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/NotificationEnums';
import { BrandApiMessages } from 'shared/components/Products/Brands/brandsuccessmesage';

const BrandService = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [brandsList, setBrandsList] = useState<BrandsList[]>([]);
  const [brand, setBrand] = useState<BrandsList>();
  const [brandResponse, setBrandResponse] = useState<BrandsList>();
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);

  /* Fetch Brands list */
  const fetchBrands = async (params?: {
    page?: number;
    size?: number;
    name?: string;
  }) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(ApiRoutes.FETCH_BRANDS, {
        params,
      });
      const data = deserialize(
        BrandsList,
        response.data['data']
      ) as BrandsList[];

      setBrandsList(data);
      setTotalPages(response.data['totalPages']);
      setTotalItems(response.data['totalItems']);
      setCurrentPage(response.data['currentPage']);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  /** Fetch Single Brand */
  const fetchSingleBrand = async (id: number) => {
    try {
      setLoading(true);
      const url = generatePath(ApiRoutes.FETCH_SINGLE_BRAND, { id });
      const response = await axiosInstance.get(url);

      const data = deserialize(
        BrandsList,
        response.data['data']['brand']
      ) as BrandsList;
      setBrand(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  /* Handle Brand delete */
  const deleteBrand = async (id: number) => {
    try {
      setLoading(true);
      const url = generatePath(ApiRoutes.DELETE_BRAND, { id });
      await axiosInstance.delete(url);
      const newArray = brandsList.filter(element => element.id !== id);
      setBrandsList(newArray);
      Notification({
        message: BrandApiMessages.BRAND_DELETED,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  /** Create brand */
  const createBrand = async (Brand: {
    name: string | undefined;
    category: string | undefined;
  }) => {
    try {
      if (!Brand.category) return;
      if (!Brand.name) return;
      setLoading(true);
      const res = await axiosInstance.post(ApiRoutes.CREATE_BRAND, Brand);
      const updatedArr = [...brandsList, res.data.data.brand as BrandsList];
      setBrandResponse(res.data.data.brand);
      await fetchBrands({ size: 20 });
      return res.data.data.brand;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  /** update Brand */
  const updateBrand = async (
    id: number,
    Brand: {
      name: string | undefined;
      category: string | undefined;
    }
  ) => {
    try {
      if (!id) return;
      if (!Brand.category) return;
      if (!Brand.name) return;
      setButtonLoading(true);
      const url = generatePath(ApiRoutes.UPDATE_BRAND, { id });
      await axiosInstance.put(url, Brand);
      await fetchBrands({ size: 20 });
      Notification({
        message: BrandApiMessages.BRAND_UPDATED,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
    } catch (error) {
    } finally {
      setButtonLoading(false);
    }
  };

  return {
    brandsList,
    brand,
    brandResponse,
    loading,
    buttonLoading,
    totalPages,
    totalItems,
    currentPage,
    fetchBrands,
    fetchSingleBrand,
    deleteBrand,
    createBrand,
    updateBrand,
  };
};

export default BrandService; 